<template>
	<div class="edit_user">
		<div class="header">Child Details</div>
		<div class="edit_item flex">
			<div class="name">Profile picture:</div>
			<el-upload
			  class="avatar-uploader"
			  action="https://api.curiouser-family.com/api/common/upload"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess">
			  <img v-if="photo" :src="imgBaseUrl + photo" class="avatar">
			  <img v-else src="../../../assets/images/icon/upload.png" alt="">
			</el-upload>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*First name：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.child_first_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Last name：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.child_last_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Gender：</div>
			<ul class="sex_list flex align-center">
				<li class="item flex align-center" @click="changeGender(1)">
					<img v-if="userInfo.gender == 1" src="../../../assets/images/icon/select_active.png" alt="">
					<img v-else src="../../../assets/images/icon/select.png" alt="">
					<div>Male</div>
				</li>
				<li class="item flex align-center" @click="changeGender(2)">
					<img v-if="userInfo.gender == 2" src="../../../assets/images/icon/select_active.png" alt="">
					<img v-else src="../../../assets/images/icon/select.png" alt="">
					<div>Female</div>
				</li>
				<li class="item flex align-center" @click="changeGender(0)">
					<img v-if="userInfo.gender == 0" src="../../../assets/images/icon/select_active.png" alt="">
					<img v-else src="../../../assets/images/icon/select.png" alt="">
					<div>prefer not to say</div>
				</li>
			</ul>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Birthday</div>
			<div class="val">
				 <el-date-picker
				      v-model="userInfo.birthday"
				      type="date"
					  local="en"
					  value-format="yyyy-MM-dd"
				      placeholder="Birthday">
				    </el-date-picker>
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Allergy ：</div>
			<div class="val">
				<input type="text" v-model="userInfo.allergy" placeholder="Is there any Allergy information that we need to be aware of?">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Medical ：</div>
			<div class="val">
				<input type="text" v-model="userInfo.medical" placeholder="Is there any medical information that we need to be aware of?">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Note：</div>
			<div class="val">
				<input type="text" v-model="userInfo.remark">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Address：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.guardian">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">School Name:</div>
			<div class="val">
				 <input type="text" placeholder="Nursery/School Name" v-model="userInfo.school_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Photo permissions</div>
			<div class="val">
				 <el-select v-model="userInfo.photo_marketing_permission" placeholder="Please select">
				    <el-option
				      v-for="item in isOptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				 </el-select>
			</div>
		</div>
		<div class="first_title">Emergency Contact 1</div>
		<div class="edit_item flex align-center">
			<div class="name">*First Name:</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_first_name_one">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Last Name:</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_last_name_one">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Mobile</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_mobile_one">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Email:</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_email_one">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Relationship to child：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.relationship_child_one">
			</div>
		</div>
		<div class="first_title">Emergency Contact 2</div>
		<div class="edit_item flex align-center">
			<div class="name">*First Name</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_first_name_two">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Last Name</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_last_name_two">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Mobile:</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_mobile_two">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Email</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.contact_email_two">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">*Relationship to child：</div>
			<div class="val">
				<input type="text" placeholder="" v-model="userInfo.relationship_child_two">
			</div>
		</div>
		
		
		<!-- <div class="edit_item flex align-center">
			<div class="name">Photo permission - internal use only:</div>
			<div class="val">
				 <el-select v-model="userInfo.photo_permission" placeholder="Please select">
				    <el-option
				      v-for="item in isOptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				 </el-select>
			</div>
		</div> -->
		
		<div class="first_title">Who will usually pick your child up ?（Optional）</div>
		<div class="edit_item flex align-center">
			<div class="name">First Name：</div>
			<div class="val">
				<input type="text" v-model="userInfo.nanny_first_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Last Name：</div>
			<div class="val">
				<input type="text" v-model="userInfo.nanny_last_name">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Contact number:：</div>
			<div class="val">
				<input type="text" v-model="userInfo.nanny_contact">
			</div>
		</div>
		<div class="edit_item flex align-center">
			<div class="name">Relationship to child：</div>
			<div class="val">
				<input type="text" v-model="userInfo.nanny_child_relationship">
			</div>
		</div>
		<div class="edit_item flex">
			<div class="name">Profile picture:</div>
			<el-upload
			  class="avatar-uploader"
			  action="https://api.curiouser-family.com/api/common/upload"
			  :show-file-list="false"
			  :on-success="handleAvatarSuccess2">
			  <img v-if="nanny_photo" :src="imgBaseUrl + nanny_photo" class="avatar">
			  <img v-else src="../../../assets/images/icon/upload.png" alt="">
			</el-upload>
		</div>
		<!-- <div class="edit_item flex align-center">
			<div class="name">保姆护照号：</div>
			<div class="val">
				<input type="text">
			</div>
		</div> -->
		<!-- <div class="edit_item flex align-center">
			<div class="name">Medical info：</div>
			<div class="val">
				<input type="text" v-model="userInfo.allergy" placeholder="Is there any medical information that we need to be aware of?">
			</div>
		</div> -->
		<!-- <div class="edit_item flex align-center">
			<div class="name">备注：</div>
			<div class="val">
				<input type="text">
			</div>
		</div> -->
		
		<div class="btn_list flex align-center">
			<div class="btn" @click="back">Cancel</div>
			<div class="btn save" @click="changeChildInfo">Save</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				userInfo:{},
				id:'',
				photo:'',
				nanny_photo:'',
				is_click:false,
				isOptions:[{
					label:'Yes',
					value:1
				},{
					label:'No',
					value:0
				}],
			}
		},
		created(){
			this.id = this.$route.query.id;
			if(this.id){
				this.getDetail()
			}
			
		},
		methods:{
			handleAvatarSuccess(file){
				this.photo = file.data.url
			},
			handleAvatarSuccess2(file){
				this.nanny_photo = file.data.url
			},
			back(){
				this.$router.back()
			},
			changeGender(index){
				this.userInfo.gender = index;
				this.$forceUpdate()
			},
			changeChildInfo(){
				if(this.is_click){
					return;
				}
				this.is_click = true;
				var params = {
					child_first_name:this.userInfo.child_first_name,
					child_last_name:this.userInfo.child_last_name,
					gender:this.userInfo.gender,
					birthday:this.userInfo.birthday,
					guardian:this.userInfo.guardian,
					contact_first_name_one:this.userInfo.contact_first_name_one,
					contact_last_name_one:this.userInfo.contact_last_name_one,
					contact_first_name_two:this.userInfo.contact_first_name_two,
					contact_last_name_two:this.userInfo.contact_last_name_two,
					contact_email_one:this.userInfo.contact_email_one,
					contact_email_two:this.userInfo.contact_email_two,
					contact_mobile_one:this.userInfo.contact_mobile_one,
					contact_mobile_two:this.userInfo.contact_mobile_two,
					relationship_child_one:this.userInfo.relationship_child_one,
					relationship_child_two:this.userInfo.relationship_child_two,
					is_school:this.userInfo.is_school,
					// photo_permission:this.userInfo.photo_permission,
					photo_marketing_permission:this.userInfo.photo_marketing_permission,
					school_name:this.userInfo.school_name,
					nanny_first_name:this.userInfo.nanny_first_name,
					nanny_last_name:this.userInfo.nanny_last_name,
					nanny_contact:this.userInfo.nanny_contact,
					nanny_child_relationship:this.userInfo.nanny_child_relationship,
					nanny_avatar:this.nanny_photo,
					medical:this.userInfo.medical,
					allergy:this.userInfo.allergy,
					id:this.id,
					child_avatar:this.photo,
					
				}
				if(!this.userInfo.child_first_name){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.child_last_name){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				
				if(!this.userInfo.contact_first_name_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_first_name_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_last_name_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_last_name_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_email_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_email_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				console.log(1)
				if(!this.userInfo.contact_mobile_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.contact_mobile_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.relationship_child_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				
				// if(!this.school_name){
				// 	this.$message('fields marked with a * are required')
				// 	return
				// }
				if(!this.userInfo.relationship_child_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				
				if(!this.userInfo.allergy){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.userInfo.medical){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(this.id){
					this.$api.post('user/editChild',params,res=>{
						if(res.code == 1){
							this.$message('modify successfully');
							this.$root.$emit('changeChild')
							setTimeout(()=>{
								this.$router.back()
							},500)
							
						}else{
							this.is_click = false;
							this.$message(res.msg)
						}
					})
				}else{
					this.$api.post('user/createChild',params,res=>{
						if(res.code == 1){
							this.$message('Succesfully saved')
							
							this.$root.$emit('changeChild')
							setTimeout(()=>{
								this.$router.back()
							},500)
						}else{
							this.is_click = false;
							this.$message(res.msg)
						}
					})
				}
				
			},
			getDetail(){
				this.$api.post('user/getChildDetails',{id:this.id},res=>{
					if(res.code == 1){
						var day = res.data.birthday.substring(0,2);
						var month = res.data.birthday.substring(3,5);
						var year = res.data.birthday.substring(6);
						res.data.birthday = year+'-'+month+'-'+day
						this.userInfo = res.data;
						this.photo = res.data.child_avatar;
						this.nanny_photo = res.data.nanny_avatar;
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.edit_user{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 0 30px 50px;
		.header{
			width: 100%;
			height: 90px;
			line-height: 90px;
			border-bottom: 1px solid #5C707A;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.first_title{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			margin-top: 20px;
		}
		.edit_item{
			margin-top: 20px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			.name{
				width: 335px;
				margin-right: 20px;
				text-align: right;
			}
			::v-deep .avatar-uploader{
				width: 122px;
				height: 122px;
			}
			::v-deep .el-upload{
				width: 100%;
				height: 100%;
			}
			::v-deep .avatar-uploader .avatar{
				width: 100%;
				height: 100%;
			}
			.val{
				width: 464px;
				height: 58px;
				border: 1px solid #282E30;
				border-radius: 10px;
				input{
					width: 100%;
					height: 100%;
					padding: 0 30px;
					line-height: 58px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #999999;
				}
			}
			.sex_list{
				.item{
					margin-right: 40px;
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					cursor: pointer;
					img{
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}
				}
			}
			::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
				width: 100%;
				height: 100%;
				border-radius: 10px;
				overflow: hidden;
			}
			::v-deep .el-input--prefix .el-input__inner{
				width: 100%;
				height: 100%;
				border: none;
				background-color: #F7F2EB;
				font-size: 24px;
				line-height: 58px;
			}
			::v-deep .el-input__prefix{
				font-size: 30px;
				right:30px;
				line-height: 58px;
			}
			::v-deep .el-select{
				width: 100%;
				height: 100%;
			}
			::v-deep .el-input.el-input--suffix{
				height: 100%;
			}
			::v-deep .el-input__icon{
				line-height: 56px;
			}
			::v-deep .el-input--suffix .el-input__inner{
				height: 100%;
				font-size: 24px;
				background-color: #F7F2EB;
				border: none;
			}
			::v-deep .el-select .el-input .el-select__caret{
				font-size: 30px;
			}
		}
		.btn_list{
			margin-top: 90px;
			padding-left: 380px;
			.btn{
				margin-right: 50px;
				width: 181px;
				height: 57px;
				border: 2px solid #5C707A;
				border-radius: 29px;
				line-height: 57px;
				text-align: center;
				font-size: 24px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #5C707A;
				cursor: pointer;
				&.save{
					background: #5C707A;
					color: #F7F2EB;
				}
			}
		}
	}
</style>